import React from "react";

export function Logo({
  className = "",
  showText = true,
  variant = "dark", // "dark" (default for light bg) | "white" / "light" / "on-coral" (for coral/orange or dark bg) | "on-black" (orange mark + white text)
  size = "md", // "xs" | "sm" | "md" | "lg" | "xl"
  onClick,
}) {
  const isWhite = variant === "white" || variant === "light" || variant === "on-coral";
  const isOnBlack = variant === "on-black";

  const sizeHeights = {
    xs: "h-5",
    sm: "h-6",
    md: "h-8",
    lg: "h-9",
    xl: "h-11",
  };

  const hasExplicitHeight = /\bh-\S+/.test(className);
  const heightClass = hasExplicitHeight ? "" : (sizeHeights[size] || "h-8");

  // Determine appropriate asset
  let src;
  if (!showText) {
    src = isWhite ? "/assets/logo-mark-white.svg" : "/assets/logo-mark.svg";
  } else if (isWhite) {
    src = "/assets/logo-horizontal-white.svg";
  } else if (isOnBlack) {
    src = "/assets/logo-horizontal-light.svg";
  } else {
    src = "/assets/logo-horizontal-dark.svg";
  }

  return (
    <div
      className={`inline-flex items-center select-none ${className}`}
      data-testid="brand-logo"
      onClick={onClick}
    >
      <img
        src={src}
        alt={showText ? "Virality AI" : "Virality"}
        className={`${heightClass} w-auto max-h-full object-contain`}
        loading="eager"
      />
    </div>
  );
}
